module.exports = __webpack_public_path__ + "static/img/close.6044d902.svg";